import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";
import InputDate from "../../helpers/InputDate";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";


function History(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

 
    const [clientsCombo, setClientsCombo] = useState(null);
    const [selectedId, setSelectedId ] = useState(defId);
    const [selectedPhrase, setSelectedPhrase ] = useState("");


    const [filterParam, setFilterParam] = useState({   


        fak_kontrahenci_id:  defId,   
       
        nazwa:  props.mainView.readFilter('hh_nazwa',''),    
        opis:  props.mainView.readFilter('hh_opis',''),   

        kwota_od:  props.mainView.readFilter('hh_kwota_od',''),   
        kwota_do:  props.mainView.readFilter('hh_kwota_do',''),   

        kwota_rozliczenia_od:  props.mainView.readFilter('hh_kwota_rozliczenia_od',''),   
        kwota_rozliczenia_do:  props.mainView.readFilter('hh_kwota_rozliczenia_do',''),   

        data_od:  props.mainView.readFilter('hh_data_od',''),   
        data_do:  props.mainView.readFilter('hh_data_do',''),   

        strona:  props.mainView.readFilter('hh_strona','_x_'),   

        typ:  props.mainView.readFilter('hh_typ','_x_'),   

 
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([        
        {
            cls:'color_deleted',
            title: 'obciążenie',
             filter: {  filed: "strona", set: "wn", typ: "combo"  },
        }, {
            cls:'color_show2',
            title: 'uznanie',
             filter: {  filed: "strona", set: "ma", typ: "combo"  },
        },
    ]);



    var dt = new Date();
    dt = dt.toLocaleDateString('en-CA');

    const [errTab, setErrTab] = useState([]); 

    const [row, setRow] = useState({

                fak_kontrahenci_id: props.id, 
                tytul_operacji: '', 
                strona: 'ma', 
                data_operacji: dt,              
                kwota: '', 
                waluta: 'PLN', 
                typ: 'PRZELEW', 
               
            });
            var tmpRow = row;

       const valChangeListenerRow = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setRow( {...tmpRow, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
                
        }



        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 5000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }




            const listenerSelectedId = (filedName, val, correct, msg) => 
        {
            setSelectedId(val);
        }

        const listenerSelectedPhrase = (filedName, val, correct, msg) => 
        {
            setSelectedPhrase(val);
        }



        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

                var defId = -1;
            if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

            props.mainView.writeFilter('hh_nazwa', ''); 
            props.mainView.writeFilter('hh_opis', '');

            props.mainView.writeFilter('hh_kwota_od', '');
            props.mainView.writeFilter('hh_kwota_do', '');

            props.mainView.writeFilter('hh_kwota_rozliczenia_od', '');
            props.mainView.writeFilter('hh_kwota_rozliczenia_do', '');

            props.mainView.writeFilter('hh_data_od', '');
            props.mainView.writeFilter('hh_data_do', '');

            props.mainView.writeFilter('hh_strona', '_');
            props.mainView.writeFilter('hh_typ', '_');
          
           
            setFilterParam({

                fak_kontrahenci_id: defId,
                nazwa: '',                                        
                opis: '',                 
                kwota_od: '',                 
                kwota_do: '',                 
                kwota_rozliczenia_od: '',                 
                kwota_rozliczenia_do: '',                 
                strona: '_x_',                 
                typ: '_x_',                 

                data_od: '',                 
                data_do: '',                 
              
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }



             const getClientsCombo = () => {
        
   
        props.mainView.showProgress();    

        fetch( Config.url + '/rest_v1_home,clients_combo', {
            method: 'POST', 
            body: JSON.stringify({all:1}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();    
                 

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setClientsCombo(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();    
         });
                   

         return false;
    }


    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_calc,history', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }




         const saveData = () => {
                

                
 

                var req = row;
                req["fak_kontrahenci_id"] = selectedId;


                props.mainView.showProgress();
                

                fetch( Config.url + '/rest_v1_calc,history_add', {
                    method: 'POST', 
                    body: JSON.stringify(row), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => { 

                    
                            props.mainView.hideProgress();
                            setView({...view, ["v"]:"list", ["id"]:-1 });  
                            getTab();

                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                            }else    
                            {
                                props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                                                                 
                                } );                                                  
                                                            
                            }
                } )
                .catch(err => {          
                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                            props.mainView.hideProgress();
                });
                        

                return false;
            }




    const remove = (e) => {

        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz usunąć ten wpis  "+title+"" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_calc,history_remove', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        setTab(null);//pobierz na nowo        
                                                        props.mainView.showDialog( "Sukces", "Pozycja została usunięta"  , "ok" , null);                             
                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie można usunać, " + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


    }




    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }


    const goEdit = (e) => {
        setView({v:'edit_item',id:-1});
    }

  

    const keyListener = (e) => {


                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(  code == 27 && (view.v == "new") )  
                        {
                                setView({v:'list',id:-1});
                        }else                                                     
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                            e.target.blur();
                            filterClear();
                        }   else     
                        if(e.target.nodeName.toLowerCase() == "body" && code == 77 ) //m - ma
                        {
                            setFilterParam( {...filterParam,["strona"]:'ma' } );
                            setTab(null);
                        }   else       
                         if(e.target.nodeName.toLowerCase() == "body" && code == 87 ) //w - wn
                        {
                            setFilterParam( {...filterParam,["strona"]:'wn' } );
                            setTab(null);
                        }   else                
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                           filterClear();
                        } else                                                                                          
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                            setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        } else                                                                  
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                               props.keyListener(e);
                        }

    }


   useEffect( ()=>{

            if(Config.env == "dev") console.log("History.js, listener on");
            window.onkeydown = keyListener;   
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("History.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );


    




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        filterClear();
        setTab(null);       
    }



    if(tab == null)
    {
        setTab([]);
        getTab();   
        getClientsCombo();      
        return <div>
            ...
        </div>
    }

 

    
    
    
    var dialogBox = null;


    if(view.v == "edit_item")
    {
        var kl = "";

        for(var k=0; k< clientsCombo.length; k++)
        {
            if(clientsCombo[k].v == selectedId)
            {
                kl = clientsCombo[k].title
                break;
            }
        }

 

        dialogBox =  <div className="dlg_window  dlg_content_white shadowx " >
                       <div className="dlg_title" >Nowa pozycja na saldzie</div>
                         <div className="dlg_msg" >

 

                                    <form className="eForm ">{kl}</form>     

                                    <br/>

                                    <form className="eForm ">

                                            <div className="form_control">        
                                                    <div className="fieldName">Tytuł / Opis*</div>
                                                    <InputText  value={row.tytul_operacji} err={errTab}  valChange={valChangeListenerRow} goNext={null} name="tytul_operacji" placeholder={""} className=' w200 ' req='1' firstUp="0" />
                                            </div> 

                                            <div className="form_control">
                                                    <div className="fieldName">Strona*</div>
                                                    <InputCombo  items={ [ {v:'ma',title:'MA'}, {v:'wn',title:'WN'}, ] } value={row.strona} err={errTab}  valChange={valChangeListenerRow} goNext={null} name="strona" placeholder={""} className='  ' req='1' firstUp="0" />
                                            </div> 

                                            <div className="form_control">
                                                    <div className="fieldName">Kwota*</div>
                                                    <InputDecimal   value={row.kwota} err={errTab}  valChange={valChangeListenerRow} goNext={null} name="kwota" placeholder={""} className='  ' req='1' firstUp="0" />
                                            </div> 

                                            <div className="form_control">        
                                                    <div className="fieldName">Data*</div>
                                                    <InputDate  value={row.data_operacji} err={errTab}  valChange={valChangeListenerRow} goNext={null} name="data_operacji" placeholder={""} className='   ' req='1' firstUp="0" />
                                            </div> 

                                            <div className="form_control">
                                                    <div className="fieldName">Typ*</div>
                                                    <InputCombo  items={ [ {v:'PRZELEW',title:'PRZELEW'}, {v:'GOTOWKA',title:'GOTOWKA'},   {v:'KOMPENSATA',title:'Kompensata'},    {v:'INNE',title:'Inne'},   ] } value={row.typ} err={errTab}  valChange={valChangeListenerRow} goNext={null} name="typ" placeholder={""} className='  ' req='1' firstUp="0" />
                                            </div> 
                                            

                                    </form>  

                                                              

                         </div>

                         <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij  </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div className="btn" atr-type="ok" onClick={saveData}>zapisz</div>
                        </div>
                         
        </div>
    }
   
 
    if(view.v == "new")
    {
        var clientFiltered = clientsCombo; 
        var selectedOneId = -1;

        if(selectedPhrase.length > 2 )
        {
            clientFiltered = new Array();

            for(var kx=0; kx < clientsCombo.length; kx++)
            {      
                if( clientsCombo[kx].title.toLowerCase().includes( selectedPhrase.toLocaleLowerCase() ) )
                {
                    clientFiltered.push(  clientsCombo[kx] );
                    selectedOneId = clientsCombo[kx].v;
                }
            }
        }

        if(clientFiltered.length == 1) {
           if(selectedId != selectedOneId)  setSelectedId(selectedOneId);
        }


        dialogBox =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Wybierz klienta</div>
                        <div className="dlg_msg" >

                   
                        <InputText   userData={props.userData} value={selectedPhrase}   valChange={listenerSelectedPhrase} goNext={goEdit} name="phrase" placeholder={"Nazwa / NIP: "}  className=' w250 '  />
                                          
                        <InputCombo items={clientFiltered}  value={selectedId} err={null}  valChange={listenerSelectedId} goNext={goEdit}   name={"selectedId"} placeholder={": "} className=' w300 ' req='0' firstUp="0" />
                            
                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij  </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div className="btn" atr-type="ok" onClick={goEdit}>dalej</div>
                        </div>
        </div>
 
    }
    
 


    
    if(view.v == 'client')
    {
     //  return <ClientReview userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id}   />
    }
 
  
        var sortList = [                          
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "kwota", name: "Kwota"  },         
        {column: "kwota_rozliczenia", name: "Kwota rozliczenia"  },         
        {column: "data_operacji", name: "Data operacji"  },         
        {column: "firma_nazwa", name: "Nazwa firmy"  },
    ]


        document.title = "Historia salda" ;


        

    var sumKwota = 0;
    var sumRozliczono = 0;
    
    for(var k=0; k<tab.length;k++)
    {
        if(tab[k].strona == 'ma')  
        {
          sumKwota = parseFloat(sumKwota) + parseFloat( tab[k].kwota );
        }

        if(tab[k].strona == 'wn')  
        {
          sumKwota = parseFloat(sumKwota) - parseFloat( tab[k].kwota );
        }


         sumRozliczono = parseFloat(sumRozliczono) + parseFloat( tab[k].kwota_rozliczenia );
    }        
        
    

    var titleRaport = "Historia salda";

    if(filterParam.data_od.length > 2)
    {
        titleRaport +=", od dnia: " + filterParam.data_od;
    }

    if(filterParam.data_do.length > 2)
    {
        titleRaport +=", do dnia: " + filterParam.data_do;
    }


    return  <div className="view_content">


                 
               <h3 className="dash_header">Historia salda</h3>
                              

    
               <div className="table_filter">

                        {
                            filterParam.fak_kontrahenci_id < 1 &&
                            <div className="filter_controll">   
                                                <label>Klient: </label>                             
                                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                            </div> 
                        }                         

                         <div className="filter_controll">   
                                            <label>Opis: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.opis}   valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Opis: "}   />
                        </div>  


                        
                        <div className="filter_controll filter_merge">   
                            <label>Kwota (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_do" placeholder={" "}   />
                        </div>

                             <div className="filter_controll filter_merge">   
                            <label>Data operacji (od / do): </label>        
                            <br/>                     
                            <InputDate   userData={props.userData}  mainView={props.mainView}  value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={" "}   />
                            <InputDate   userData={props.userData}  mainView={props.mainView}  value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={" "}   />
                        </div>
  


                        <div className="filter_controll">   
                                            <label>Strona: </label>                             
                                            <InputCombo items={ [  {v:'_x_', title: '- - - '},  {v:'wn', title: 'Obciążenie (WN) [w]'} ,  {v:'ma', title: 'Uznanie (MA) [m]'} ] }  userData={props.userData} value={filterParam.strona}   valChange={valChangeListener} goNext={goNextNew} name="strona" placeholder={": "}   />
                        </div>  

                         <div className="filter_controll">   
                                            <label>Źródło: </label>                             
                                            <InputCombo items={ [  {v:'_x_', title: '- - - '},  {v:'FAKTURA', title: 'FAKTURA'} ,  {v:'PRZELEW', title: 'PRZELEW'} , {v:'P24', title: 'Przelewy24'}  ] }  userData={props.userData} value={filterParam.typ}   valChange={valChangeListener} goNext={goNextNew} name="typ" placeholder={": "}   />
                        </div> 
                        

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                                                    

                             <div className="btn" onClick={changeView} v="new" id="-1"  > Dodaj wpis</div>

                              &nbsp;&nbsp;

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  /> 
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />



                                    &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />



                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


               <div className="bg_center">


                  <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3>  
                                     <table className="table"  ref={tab2Ref} >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Data operacji</td>                                                                                                                                                                                              
                                                <td>Klient</td>                                                                                                                                                                                              
                                                <td>Tytuł</td>                                                                                                                                                                                                                                   
                                                <td>Strona / Typ</td>                                                                                                                                                                                                                                   
                                                <td className="td_right">Kwota przelewu</td>                                                    
                                                                                                 
                                                                                                        
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
 
                                                            if(row.strona =='wn' ) rowStyle += " color_deleted "
                                                            if(row.strona =='ma' ) rowStyle += " color_show2 "

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="gocenter" v="details" id={row.id} onClick={changeView}>{row.data_operacji}</td>                                                                                                       
                                                                <td className="goleft" v="details" id={row.id} onClick={changeView}>{row.klient.nazwa}</td>                                                                                                       
                                                                <td className="goleft" v="details" id={row.id} onClick={changeView}>{row.opis}</td>                                                                                                                                                                               
                                                                <td className="gocenter">
                                                                    {row.strona == 'ma' && <span>Uznanie (MA)</span>}
                                                                    {row.strona == 'wn' && <span>Obciążenie (WN)</span>}
                                                                </td>                                                                                                                                                                               
                                                                <td className="goright" ><FormatDecimal value={row.kwota} /> </td>                                                                                                                                                                                                                                                                                                                                                

                                                              

                                                            </tr>

                                                    } )
                                                }

                                            <tr>                                                                                               
                                                <td></td>   
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                                                                   
                                                <td> </td>                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={sumKwota} /></td>                                                                                                                                                  
                                            </tr>

                                        </tbody>

                                </table>    
                  </div>

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Data operacji</td>                                                                                                                                                                                              
                                                {
                                                    props.fak_kontrahenci_id == undefined && 
                                                    <td>Nazwa</td>
                                                }                                                                                                                                                                                             
                                                <td>Tytuł</td>                                                                                                                                                                                                                                   
                                                <td>Strona / Typ</td>                                                                                                                                                                                                                                   
                                                <td>Źródło</td>                                                                                                                                                                                                                                   
                                                <td className="td_right">Kwota przelewu</td>                                                    
                                                <td className="td_option"> </td>                                                    
                                                                                                        
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
 
                                                            if(row.strona =='wn' ) rowStyle += " color_deleted "
                                                            if(row.strona =='ma' ) rowStyle += " color_show2 "

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="gocenter" v="details" id={row.id} onClick={changeView}>{row.data_operacji}</td>                                                                                                       

                                                                {
                                                                  props.fak_kontrahenci_id == undefined && 
                                                                  <td className="goleft" v="details" id={row.id} onClick={changeView}>{row.klient.nazwa}</td> 
                                                                } 
                                                                                                                                                                      
                                                                <td className="goleft" v="details" id={row.id} onClick={changeView}>{row.opis}</td>                                                                                                                                                                               
                                                                <td className="gocenter">
                                                                    {row.strona == 'ma' && <span>Uznanie (MA)</span>}
                                                                    {row.strona == 'wn' && <span>Obciążenie (WN)</span>}
                                                                </td>   
                                                                <td className="goleft" v="details" id={row.id} onClick={changeView}>{row.typ}</td>                                                                                                                                                                              
                                                                <td className="goright" ><FormatDecimal value={row.kwota} /> </td>                                                                                                                                                                                                                                                                                                                                                

                                                                 <MenuTable>
                                                                    <ul>     
                                                                        {
                                                                            row.typ == 'NONE' &&
                                                                            <li   atr-id={row.id} atr-title={row.opis + " klienta " + row.kwota } onClick={remove}>Usuń</li>
                                                                        }     
                                                                        {
                                                                            row.typ != 'NONE' &&
                                                                            <li   >Blokada</li>
                                                                        }                                                                                                                                        
                                                                    </ul>
                                                                </MenuTable>

                                                            </tr>

                                                    } )
                                                }

                                            <tr>                                                                                               
                                           
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                {
                                                    props.fak_kontrahenci_id == undefined && 
                                                    <td> </td>
                                                }                                                                                                                                                                                             
                                                <td> </td>                                                                                                                                                                                                                                   
                                                <td> </td>                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={sumKwota} /></td>                                                                                                                                                  
                                            </tr>

                                        </tbody>

                                </table>

               </div>
 
              

                              
           {dialogBox}

    </div>
}


export default History;